/**
 * Shared motion presets — aligned with Refined Motion (spring + quart-out entrances).
 */

/** Quart-out — smooth deceleration at end of entrances */
export const EASE_ENTRANCE = [0.23, 1, 0.32, 1];
export const EASE_SMOOTH = [0.22, 1, 0.36, 1];
export const EASE_EXIT = [0.4, 0, 0.2, 1];

export const DURATION_FAST = 0.18;
export const DURATION_NORMAL = 0.32;
export const DURATION_SLOW = 0.48;

export const springGentle = { type: 'spring', stiffness: 380, damping: 30 };
export const springSoft = { type: 'spring', stiffness: 260, damping: 28 };

export const fadeUp = {
  initial: { opacity: 0, y: 12 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -6 },
};

export const crossfade = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
};

export const viewTransition = {
  initial: { opacity: 0, y: 16, scale: 0.995 },
  animate: { opacity: 1, y: 0, scale: 1 },
  exit: { opacity: 0, y: -10, scale: 0.995 },
};

export const titleSwap = {
  initial: { opacity: 0, y: 10 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -10 },
};

export const entranceTransition = {
  duration: DURATION_NORMAL,
  ease: EASE_ENTRANCE,
};
